import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AUTH } from "@/constants/testIds";
import { AuthScaffold } from "@/pages/auth/Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", name: "", phone: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    const res = await register({
      email: form.email.trim(),
      password: form.password,
      name: form.name.trim(),
      phone: form.phone.trim() || null,
    });
    setBusy(false);
    if (res.ok) navigate("/dashboard", { replace: true });
    else setError(res.error);
  };

  return (
    <AuthScaffold>
      <form onSubmit={onSubmit} data-testid={AUTH.registerForm} className="space-y-5">
        <div className="space-y-1">
          <div className="eyebrow">Join the ecosystem</div>
          <h1 className="font-anton text-4xl sm:text-5xl uppercase leading-none">Create account</h1>
          <p className="text-lifted-dim text-sm">Starts as a Customer. Roles can be granted by admins.</p>
        </div>

        <div>
          <label className="lifted-label">Full name</label>
          <input className="input-lifted" required value={form.name} onChange={update("name")} data-testid={AUTH.registerName} placeholder="Jane Lifted" />
        </div>
        <div>
          <label className="lifted-label">Email</label>
          <input className="input-lifted" type="email" required value={form.email} onChange={update("email")} data-testid={AUTH.registerEmail} placeholder="you@liftedatthemoment.com" />
        </div>
        <div>
          <label className="lifted-label">Phone (optional)</label>
          <input className="input-lifted" value={form.phone} onChange={update("phone")} data-testid={AUTH.registerPhone} placeholder="+1 555-…" />
        </div>
        <div>
          <label className="lifted-label">Password</label>
          <input className="input-lifted" type="password" required minLength={8} value={form.password} onChange={update("password")} data-testid={AUTH.registerPassword} placeholder="min 8 characters" />
        </div>

        {error && (
          <div data-testid={AUTH.registerError} className="text-sm text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-md px-3 py-2">
            {error}
          </div>
        )}

        <button type="submit" disabled={busy} className="btn-lifted w-full" data-testid={AUTH.registerSubmit}>
          {busy ? "Creating…" : "Create account"}
        </button>

        <div className="pt-2 text-xs text-lifted-dim text-center">
          Already have an account?{" "}
          <Link to="/auth/login" data-testid={AUTH.goLogin} className="text-lifted-green hover:underline font-bebas tracking-widest">
            Sign in →
          </Link>
        </div>
      </form>
    </AuthScaffold>
  );
}
